/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Summary of a rollout wave for tenant display.
 */
export interface RolloutWaveTenantSummary { 
    /**
     * Rollout Wave ID.
     */
    id?: string;
    /**
     * User friendly name for the wave.
     */
    name?: string;
    /**
     * Scheduled execution start time for the wave.
     */
    window_start_time?: Date;
    /**
     * Scheduled execution end time for the wave.
     */
    window_end_time?: Date;
}

